/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface FetchDiscourseConnectRedirectUrlBody
 */
export interface FetchDiscourseConnectRedirectUrlBody {
  /**
   * Payload value from SSO source.
   * @type string
   * @memberof FetchDiscourseConnectRedirectUrlBody
   */
  sso: string
  /**
   * Signature value from SSO source.
   * @type string
   * @memberof FetchDiscourseConnectRedirectUrlBody
   */
  sig: string
  /**
   * URL for SSO app to return to after SSO process.
   * @type string
   * @memberof FetchDiscourseConnectRedirectUrlBody
   */
  returnURL?: string
}

export function FetchDiscourseConnectRedirectUrlBodyFromJSON(
  json: any
): FetchDiscourseConnectRedirectUrlBody {
  return FetchDiscourseConnectRedirectUrlBodyFromJSONTyped(json, false)
}

export function FetchDiscourseConnectRedirectUrlBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDiscourseConnectRedirectUrlBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sso: json['sso'],
    sig: json['sig'],
    returnURL: !exists(json, 'ReturnURL') ? undefined : json['ReturnURL'],
  }
}

export function FetchDiscourseConnectRedirectUrlBodyToJSON(
  value?: FetchDiscourseConnectRedirectUrlBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    sso: value.sso,
    sig: value.sig,
    ReturnURL: value.returnURL,
  }
}
